import { render, staticRenderFns } from "./softwareApp.vue?vue&type=template&id=211772c4&scoped=true"
import script from "./softwareApp.vue?vue&type=script&lang=js"
export * from "./softwareApp.vue?vue&type=script&lang=js"
import style0 from "./softwareApp.vue?vue&type=style&index=0&id=211772c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211772c4",
  null
  
)

export default component.exports